export enum EBannerType {
  FSK = 'fskLanding',
}

export interface IPostViewEventItem {
  action: 'show' | 'click';
  bannerType: EBannerType.FSK;
  bannerPlace: string;
  timestamp: number;
  dl?: string; // window.location.href
}

export interface IPostViewEvent {
  user_id?: number | null;
  pageType: string;
  device_type: string;
  cid: string;
  items: IPostViewEventItem[];
}
